import {
  KeyboardArrowDown,
  KeyboardArrowUp,
  Warning,
} from "@mui/icons-material";
import {
  Checkbox,
  Collapse,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Tooltip,
  Typography,
} from "@mui/material";
import { getExpiryDate, isValidAvailableSeats } from "data/functions";
import { ServiceClaim, ServiceSummary } from "data/interfaces";
import { useState } from "react";

interface ClaimSelectionItemDropdownProps {
  service: ServiceSummary;
  claim: ServiceClaim;
  primaryText: string;
  secondaryText: string | null;
  selectedUsersCount: number;
  userHasClaimTypeAndValue: (
    licenseReference: string,
    claimType: string,
    claimValue: string
  ) => boolean;
  handleCheckboxSelect: (
    checked: boolean,
    service: ServiceSummary,
    claim: ServiceClaim,
    claimValue: string
  ) => void;
}

export function ClaimSelectionItemDropdown({
  service,
  claim,
  primaryText,
  secondaryText,
  selectedUsersCount,
  userHasClaimTypeAndValue,
  handleCheckboxSelect,
}: ClaimSelectionItemDropdownProps) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <ListItem disablePadding>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs>
            <Tooltip placement="left" title={getExpiryDate(service)}>
              <ListItemText primary={primaryText} secondary={secondaryText} />
            </Tooltip>
          </Grid>
          <Grid item xs="auto">
            {!isValidAvailableSeats(service, selectedUsersCount) ? (
              <>
                <Typography variant="caption" color="error" sx={{ pr: 1 }}>
                  {`${
                    service.seatsTotal - service.seatsUsed
                  } seat(s) available`}
                </Typography>
                <Warning color="error" />
              </>
            ) : (
              <Typography variant="caption">
                {service.unlimitedSeats === true
                  ? "Unlimited"
                  : `${
                      service.seatsTotal - service.seatsUsed
                    } seat(s) available`}
              </Typography>
            )}
          </Grid>
          <Grid item xs={1}>
            <IconButton onClick={() => setOpen(!open)}>
              {open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
            </IconButton>
          </Grid>
        </Grid>
      </ListItem>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {claim.options
            .sort((a, b) =>
              a.claimValueDescription > b.claimValueDescription ? 1 : -1
            )
            .map((option) => (
              <ListItem key={option.claimValue} disablePadding sx={{ pl: 3 }}>
                <ListItemText secondary={option.claimValueDescription} />
                <Checkbox
                  disabled={!isValidAvailableSeats(service, selectedUsersCount)}
                  defaultChecked={userHasClaimTypeAndValue(
                    service.licenseReference,
                    claim.claimType,
                    option.claimValue
                  )}
                  edge="end"
                  onChange={(e, checked) =>
                    handleCheckboxSelect(
                      checked,
                      service,
                      claim,
                      option.claimValue
                    )
                  }
                />
              </ListItem>
            ))}
        </List>
      </Collapse>
    </>
  );
}
